<app-table
  #table
  storageKey="incomestatementListTable"
  [columns]="columns"
  [data]="list$ | async"
  [rowsPerPage]="defaultNumberOfRows"
  sortField="client"
  exportFilename="kontrolluppgifter"
  (pageChange)="paginatorTriggered($event)"
>
  <app-table-filter>
    <app-team-multi-selector localStorageKey="incomestatement" (OnTeamsInit)="refreshList()"></app-team-multi-selector>
    <app-table-filter-item label="Klientansvarig">
      <app-user-selector [(userId)]="selectedClientResponsibleUserId" styleClass="min-w-48"></app-user-selector>
    </app-table-filter-item>
    <app-table-filter-item label="Utförande handläggare">
      <app-user-selector [(userId)]="selectedTaskUserId" styleClass="min-w-48"></app-user-selector>
    </app-table-filter-item>
    <app-table-filter-item label="År som avses">
      <app-year-selector [(year)]="selectedYear"></app-year-selector>
    </app-table-filter-item>
    <app-table-filter-item>
      <app-table-refresh-button [loading]="loading$ | async" (onClick)="refreshList()"></app-table-refresh-button>
    </app-table-filter-item>
    <app-table-filter-item>
      <p-checkbox
        [binary]="true"
        [(ngModel)]="includeAllDoneClients"
        (ngModelChange)="filterList()"
        [label]="includeFinishedLabel$ | async"
      ></p-checkbox>
    </app-table-filter-item>
  </app-table-filter>

  <ng-template tableTemplate="bodyCell" tableBodyCellField="client" let-client="rowData">
    <a (click)="onShowExistingClient(client.clientId)" class="cursor-pointer text-black">{{ client.client }}</a>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="corporateIdentity" let-client="rowData">
    <a (click)="onShowExistingClient(client.clientId)" class="cursor-pointer text-black">
      {{ client.corporateIdentity }}
    </a>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="customerNumber" let-client="rowData">
    <a (click)="onShowExistingClient(client.clientId)" class="cursor-pointer text-black">
      {{ client.customerNumber }}
    </a>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="konu.activity.state.description"
    let-activity="rowData.konu"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="eulo.activity.state.description"
    let-activity="rowData.eulo"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="eura.activity.state.description"
    let-activity="rowData.eura"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="kuut.activity.state.description"
    let-activity="rowData.kuut"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="fora.activity.state.description"
    let-activity="rowData.fora"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="rest.activity.state.description"
    let-activity="rowData.rest"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="sral.activity.state.description"
    let-activity="rowData.sral"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="program" let-data="rowData">
    <div class="text-center">
      <app-bla-icon-button [composite]="data"></app-bla-icon-button>
    </div>
  </ng-template>

  <ng-template tableTemplate="emptyMessage">{{ statusText$ | async }}</ng-template>

  <ng-template tableTemplate="summary" let-data>
    <div class="relative">
      Antal aktuella klienter: {{ data.length }}
      <div class="absolute export-button-wrapper">
        <bl-frontend-button
          density="slim"
          [leadingIcon]="{name: 'download'}"
          text="Exportera lista"
          (onclick)="table.exportCSV()"
          title="Ladda ner listan för import till Excel"></bl-frontend-button>
      </div>
    </div>
  </ng-template>

  <ng-template #defaultCompositeColumn let-activity>
    <div
      class="flex justify-start items-center cursor-pointer"
      (click)="onShowActivity(activity)">
      <app-status-icon
        [status]="activity.activity.alertLevel.name"
        [title]="activity.activity.state.description"
        [tooltip]="activity.activity.alertLevel.description"
      ></app-status-icon>
      <app-activity-comment-icon [tooltip]="activity.activity.comment" classIfVisible="ml-2"></app-activity-comment-icon>
      <app-task-comment-icon [tooltip]="activity.task.comment" classIfVisible="ml-2"></app-task-comment-icon>
    </div>
  </ng-template>
</app-table>
